import React, { createContext, useContext, useState, useEffect } from 'react';

const BrandingContext = createContext();

const DEFAULT_BRANDING = {
  logo: '/branding/condutor-online-logo.png',
  companyName: 'condutor.online',
  companySubtitle: 'Plataforma de Gestão de Frotas',
  sidebarColor: '#0f172a',   // slate-900
  accentColor: '#4f46e5',    // indigo-600 (matches new pin logo)
};

const STORAGE_KEY = 'fleetcontrol_branding';

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        const parsed = JSON.parse(saved);
        // Migrate legacy values (null logo, old blue accent, FleetControl name) to new defaults
        const migrated = { ...DEFAULT_BRANDING, ...parsed };
        if (!parsed.logo || parsed.logo === '/branding/logo-default.png') migrated.logo = DEFAULT_BRANDING.logo;
        if (parsed.accentColor === '#2563eb') migrated.accentColor = DEFAULT_BRANDING.accentColor;
        if (parsed.companyName === 'FleetControl') migrated.companyName = DEFAULT_BRANDING.companyName;
        if (parsed.companySubtitle === 'Gestão de Frotas') migrated.companySubtitle = DEFAULT_BRANDING.companySubtitle;
        return migrated;
      }
    } catch (e) {
      console.error('Error loading branding:', e);
    }
    return DEFAULT_BRANDING;
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(branding));
    } catch (e) {
      console.error('Error saving branding:', e);
    }
  }, [branding]);

  const updateBranding = (updates) => {
    setBranding(prev => ({ ...prev, ...updates }));
  };

  const resetBranding = () => {
    setBranding(DEFAULT_BRANDING);
    localStorage.removeItem(STORAGE_KEY);
  };

  return (
    <BrandingContext.Provider value={{ branding, updateBranding, resetBranding, DEFAULT_BRANDING }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => {
  const context = useContext(BrandingContext);
  if (!context) {
    throw new Error('useBranding must be used within a BrandingProvider');
  }
  return context;
};
